import React from "react";

const ChangeFontSize = ({canUndo, onClick}) => {
  return (
    <svg width="26" height="16" role="img" aria-label="Change Font Size" viewBox="0 0 26 16" fill="none">
        <path fill="#576579" stroke="#576579" strokeLinecap="round" strokeLinejoin="round" strokeWidth=".5" d="M8.35 11.75h.734l-3.378-7.5h-.768l-3.354 7.5h.733L3.33 9.485h4.007L8.35 11.75ZM3.575 8.927l.57-1.285c.268-.622.804-1.822 1.177-2.718.373.896.908 2.096 1.188 2.718l.57 1.285H3.575ZM22.16 14h1.174L17.93 2H16.7l-5.366 12h1.173l1.622-3.624h6.41L22.159 14Zm-7.64-4.517.913-2.056c.428-.994 1.286-2.916 1.882-4.348a191.602 191.602 0 0 0 1.9 4.348l.913 2.056H14.52Z"/>
    </svg>
  );
};

export default ChangeFontSize;
